<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}
        <a class="button is-success is-pulled-right" @click="newComment">
          New Comment
        </a>
        </p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Comments</label>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Departament</th>
                <th>Resume</th>
                <th>Date</th>
                <th>Files</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="comments.length > 0">
                <tr v-for="comment in comments">
                  <td>{{comment.id}}</td>
                  <td>{{comment.user.name}}</td>
                  <td>{{parseDepartment(comment.department)}}</td>
                  <td>{{comment.comment}}</td>
                  <td>{{comment.created_at}}</td>
                  <td style="text-align: center">
                    <tooltip label="Files" type="default" placement="left" v-if="parseInt(comment.attachments) === 1">
                      <a class="button button-table is-small" @click="attachments()">
                        <i class="fa fa-files-o"></i>
                      </a>
                    </tooltip>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="6" style="text-align: center;">No comments</td>
                </tr>
              </template>
            </tbody>
          </table>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import Comment from './comment'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      chain_id: {
        type: Number
      },
      provider_id: {
        type: Number
      },
      agency_id: {
        type: Number
      },
      hotel_id: {
        type: Number
      },
      edit: {
        type: Boolean
      }
    },
    data () {
      return {
        comments: [],
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      attachments () {
        let propsData = {
          context: this.context,
          hotel_id: this.hotel_id,
          agency_id: this.agency_id,
          chain_id: this.chain_id,
          provider_id: this.provider_id,
          callback: 'loadData'
        }
        Comment.openCommentAttachments(propsData)
      },
      parseDepartment (content) {
        return this.context.$store.state.config.departaments[content].name
      },
      newComment () {
        let propsData = {
          context: this.context,
          parent: this,
          chain_id: this.chain_id,
          provider_id: this.provider_id,
          agency_id: this.agency_id,
          hotel_id: this.hotel_id,
          title: 'New Comment',
          callback: 'loadData',
          edit: false
        }
        Comment.openComment(propsData)
      },
      loadData () {
        let url = ''
        let id = null
        if (this.chain_id) {
          url = '/comments/chain/'
          id = this.chain_id
        } else if (this.provider_id) {
          url = '/comments/provider/'
          id = this.provider_id
        } else if (this.agency_id) {
          url = '/comments/agency/'
          id = this.agency_id
        } else if (this.hotel_id) {
          url = '/comments/hotel/'
          id = this.hotel_id
        }
        this.context.$http.get(this.context.$store.state.config.apiURL + url + id).then((response) => {
          this.comments = response.body
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      Tooltip
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// Comments.vue?01b4bba7